// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3e5a3646","239":"b8cf69be","455":"1c2af5dc","633":"c11f6645","749":"a24d64a4","762":"c3043b42","903":"7f20d139"}[chunkId] + ".chunk.js";
};